import React from 'react';

// Styles & Assets
import styles from './CasesPaginator.module.css';
import { MdKeyboardArrowLeft } from 'react-icons/md';

// Interfaces
interface Props {
    currentPage: number;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>
    numPages: number;

}

const CasesPaginator: React.FC<Props> = ({ currentPage, numPages, setCurrentPage }) => {

    const goPreviousPage = () => setCurrentPage(x => x - 1 <= 0 ? 0 : x - 1);

    const goNextPage = () => setCurrentPage(x => x + 1 >= numPages ? numPages : x + 1);

    return (
        <div className={styles.tablePaginator}>
            <button className={styles.buttonPage} disabled={currentPage <= 1} onClick={goPreviousPage}>
                <MdKeyboardArrowLeft />
            </button>
            {Array(numPages).fill(null).map((_, i) =>
                <button
                    key={i}
                    className={`${styles.buttonPage} ${currentPage !== (i + 1) ? styles.notActiveButton : styles.activeButton}`}
                    onClick={() => setCurrentPage(i + 1)}
                >
                    {i + 1}
                </button>
            )}
            <button className={styles.buttonPage} disabled={currentPage >= numPages} onClick={goNextPage}>
                <MdKeyboardArrowLeft />
            </button>
        </div>
    );
};

export default CasesPaginator;